export const ALL_COMMUNITIES_CHOICE = { id: 0, name: 'all' };

export default { ALL_COMMUNITIES_CHOICE };
